import { IRootState } from 'app/shared/reducers';
import { createSelector } from 'reselect';
import { StepState } from './step.state';

const selectStepState: any = (state: IRootState) => state.step;

export const getNbSteps = createSelector<IRootState, StepState, any>(
  selectStepState,
  (stepStore: StepState) => Object.values(stepStore.journeySteps).length
);

export const isEndStep = createSelector<IRootState, StepState, any>(selectStepState, (stepStore: StepState) => {
  const currentStep = stepStore.journeyStepsList[stepStore.currentStep - 1];
  return currentStep === 'endStep';
});

export const isTooEarlyStep = createSelector<IRootState, StepState, any>(selectStepState, (stepStore: StepState) => {
  const currentStep = stepStore.journeyStepsList[stepStore.currentStep - 1];
  return currentStep === 'tooEarlyStep';
});

export const nbShowStepActions = createSelector<IRootState, StepState, any>(
  selectStepState,
  (stepStore: StepState) => Object.values(stepStore.journeySteps).filter(step => step.showStepActions).length
);

export const getCurrentStep = createSelector<IRootState, StepState, any>(
  selectStepState,
  (stepStore: StepState) => stepStore.currentStep 
);

export const getPreviousStep = createSelector<IRootState, StepState, any>(
  selectStepState,
  (stepStore: StepState) => stepStore.previousStep
);

export const getCurrentPageType = createSelector<IRootState, StepState, any>(
  selectStepState,
  (stepStore: StepState) => stepStore.journeySteps[stepStore.journeyStepsList[stepStore.currentStep - 1]].cmsType
);

export const getCurrentShowStepActions = createSelector<IRootState, StepState, any>(
  selectStepState,
  (stepStore: StepState) => stepStore.journeySteps[stepStore.journeyStepsList[stepStore.currentStep - 1]].showStepActions
);

export const getCurrentComponent = createSelector<IRootState, StepState, any>(
  selectStepState,
  (stepStore: StepState) => stepStore.journeySteps[stepStore.journeyStepsList[stepStore.currentStep - 1]].component
);

export const getCurrentJourneyStep = createSelector<IRootState, StepState, any>(
  selectStepState,
  (stepStore: StepState) => stepStore.journeyStepsList[stepStore.currentStep - 1]
);
